import React from 'react';
import Footer1 from './Footer1';
import Footer2 from './Footer2';
import Footer3 from './Footer3';
import Footer4 from './Footer4';

const Footer = ({ toggleLanguage, currentLang }) => {
  return (
    <>
      <Footer1 toggleLanguage={toggleLanguage} currentLang={currentLang} />
      {/* <Footer2 toggleLanguage={toggleLanguage} currentLang={currentLang} /> */}
      <Footer3 toggleLanguage={toggleLanguage} currentLang={currentLang} />
      <Footer4 toggleLanguage={toggleLanguage} currentLang={currentLang} />
    </>
  );
};

export default Footer;
